const getSvgContent = (svgString) => {
    const match = svgString.match(/<svg (.*?)>(.*?)<\/svg>/);
    const attributes = {};
    let currentAttribute = [];
    if (match) {
        const [, attributesString, innerHTML] = match;
        const getAttributes = /(\S*?)="(.*?)"/g;
        while ((currentAttribute = getAttributes.exec(attributesString)) !== null) {
            attributes[currentAttribute[1]] = currentAttribute[2];
        }
        return {
            attributes,
            innerHTML,
        };
    }
    return {
        attributes,
        innerHTML: "",
    };
};

export { getSvgContent };
//# sourceMappingURL=Icon.utils.js.map
